var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _rect5, _path5, _path6, _rect6, _rect7, _rect8, _rect9, _path7, _path8, _path9, _path10, _path11, _path12, _rect10, _path13, _rect11, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelScreening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 557,
    height: 128,
    viewBox: "0 0 557 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -4,
    width: 738,
    height: 554,
    fill: "#979BC4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 365,
    width: 92.25,
    height: 92.3333,
    fill: "#414780"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 272.75,
    width: 92.25,
    height: 92.3333,
    fill: "#414780"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 272.75,
    y: 92.3333,
    width: 92.25,
    height: 92.3333,
    fill: "#878BB6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.75 46.125C272.75 20.6509 293.401 0 318.875 0C344.349 0 365 20.6509 365 46.125V92.3333H272.75V46.125Z",
    fill: "#878BB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M549.5 138.458C549.5 112.984 570.151 92.3333 595.625 92.3333C621.099 92.3333 641.75 112.984 641.75 138.458V184.667H549.5V138.458Z",
    fill: "#565B8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M365 138.458C365 112.984 385.651 92.3333 411.125 92.3333C436.599 92.3333 457.25 112.984 457.25 138.458V184.667H365V138.458Z",
    fill: "#565B8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5 138.458C180.5 112.984 201.151 92.3333 226.625 92.3333C252.099 92.3333 272.75 112.984 272.75 138.458V184.667H181.051C180.747 184.667 180.5 184.42 180.5 184.116V138.458Z",
    fill: "#B6B9D5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 318.875,
    y: -46.1667,
    width: 92.25,
    height: 92.3333,
    rx: 46.125,
    fill: "#878BB6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.25 92.3333H549.5C549.5 117.83 528.849 138.5 503.375 138.5C477.901 138.5 457.25 117.83 457.25 92.3333Z",
    fill: "#0C1356"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365 -46.1667C365 -20.6696 344.349 -8.01086e-05 318.875 -8.01086e-05C318.875 -25.4972 339.526 -46.1667 365 -46.1667ZM272.75 46.1666C272.75 20.6694 293.401 -8.01086e-05 318.875 -8.01086e-05C318.875 25.4971 298.224 46.1666 272.75 46.1666ZM318.875 -8.01086e-05C293.401 -8.01086e-05 272.75 -20.6696 272.75 -46.1667C298.224 -46.1667 318.875 -25.4972 318.875 -8.01086e-05ZM318.875 -8.01086e-05C344.349 -8.01086e-05 365 20.6694 365 46.1666C339.526 46.1666 318.875 25.4971 318.875 -8.01086e-05Z",
    fill: "#0C1356"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 549.5,
    width: 92.25,
    height: 92.3333,
    fill: "#565B8C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: 92.3333,
    width: 92.25,
    height: 92.3333,
    fill: "#878BB6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 457.25,
    width: 92.25,
    height: 92.3333,
    fill: "#0C1356"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 88.25,
    y: 92.3333,
    width: 92.25,
    height: 92.3333,
    fill: "#B6B9D5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.5 92.3332H88.25C88.25 66.836 108.901 46.1665 134.375 46.1665C159.849 46.1665 180.5 66.836 180.5 92.3332Z",
    fill: "#B6B9D5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.5 0C180.5 25.4971 159.849 46.1667 134.375 46.1667C134.375 20.6695 155.026 0 180.5 0Z",
    fill: "#0C1356"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.25 92.3332C88.25 66.836 108.901 46.1665 134.375 46.1665C134.375 71.6637 113.724 92.3332 88.25 92.3332Z",
    fill: "#414780"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.438 178.468C143.651 170.486 134.375 155.566 134.375 138.478C134.375 121.39 143.651 106.47 157.438 98.4873C171.224 106.47 180.5 121.39 180.5 138.478C180.5 155.566 171.224 170.486 157.438 178.468Z",
    fill: "#0C1356"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365 92.3333C365 117.83 344.349 138.5 318.875 138.5C318.875 113.003 339.526 92.3333 365 92.3333Z",
    fill: "#414780"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.25 92.3333C88.25 117.83 67.5991 138.5 42.125 138.5C42.125 113.003 62.7759 92.3333 88.25 92.3333Z",
    fill: "#8F93B9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -4,
    width: 92.25,
    height: 92.3333,
    rx: 46.125,
    fill: "#0C1356"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.307 115.417C535.332 129.216 520.425 138.5 503.353 138.5C486.28 138.5 471.374 129.216 463.398 115.417C471.374 101.617 486.28 92.3333 503.353 92.3333C520.425 92.3333 535.332 101.617 543.307 115.417Z",
    fill: "#878BB6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 388.062,
    y: 115.417,
    width: 46.125,
    height: 46.1667,
    rx: 23.0625,
    fill: "#8F93B9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M641.75 46.1665C641.75 71.6637 621.099 92.3332 595.625 92.3332C595.625 66.836 616.276 46.1665 641.75 46.1665ZM549.5 138.5C549.5 113.003 570.151 92.3332 595.625 92.3332C595.625 117.83 574.974 138.5 549.5 138.5ZM595.625 92.3332C570.151 92.3332 549.5 71.6637 549.5 46.1665C574.974 46.1665 595.625 66.836 595.625 92.3332ZM595.625 92.3332C621.099 92.3332 641.75 113.003 641.75 138.5C616.276 138.5 595.625 117.83 595.625 92.3332Z",
    fill: "#414780"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5 0H272.75V46.2083C272.75 71.6825 252.099 92.3333 226.625 92.3333C201.151 92.3333 180.5 71.6825 180.5 46.2083V0Z",
    fill: "#0C1356"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.625 46.1667C226.625 20.6695 247.276 0 272.75 0C272.75 25.4971 252.099 46.1667 226.625 46.1667Z",
    fill: "#565B8C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.25 -46.1667C88.25 -20.6696 67.5991 -8.01086e-05 42.125 -8.01086e-05C42.125 -25.4972 62.7759 -46.1667 88.25 -46.1667ZM88.25 46.1666C62.7759 46.1666 42.125 25.4971 42.125 -8.01086e-05C67.5991 -8.01086e-05 88.25 20.6694 88.25 46.1666ZM42.125 -8.01086e-05C16.6509 -8.01086e-05 -4 -20.6696 -4 -46.1667C21.4741 -46.1667 42.125 -25.4972 42.125 -8.01086e-05ZM42.125 -8.01086e-05C42.125 25.4971 21.4741 46.1666 -4 46.1666C-4 20.6694 16.6509 -8.01086e-05 42.125 -8.01086e-05Z",
    fill: "#414780"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelScreening);
export default __webpack_public_path__ + "static/media/cancel-screening.8ff8246d8261ed79159fd89fd23d65e6.svg";
export { ForwardRef as ReactComponent };